import interceptors from "./interceptors";
import { SMU_SELECTED_MENU } from "../constants";

// Auxiliary: get selected menu id from localStorage (or null)
const getSelectedMenuId = () => {
  const savedSelectedMenu = localStorage.getItem(SMU_SELECTED_MENU);
  if (!savedSelectedMenu) return null;
  try {
    const parsedMenu = JSON.parse(savedSelectedMenu);
    const menuId = parsedMenu?.id;
    if (menuId !== null && menuId !== undefined && menuId !== 0) {
      return menuId;
    }
  } catch (err) {
    // If parsing fails, continue without category_menu
    console.error("Error parsing SMU_SELECTED_MENU:", err);
  }
  return null;
};

// TO BE DEPRECATED IN FAVOR OF fetchFaldonesByCategoryAndTienda
const fetchFiles = (category, limit) => {
  return interceptors({
    url: `/documents/document/${category}${!!limit ? "?latest=" + limit : ""}`,
    method: "GET",
  });
};

// TO BE DEPRECATED IN FAVOR OF downloadFaldonXlsx
const downloadFile = (category, id) => {
  return interceptors({
    url: `/documents/document/${category}/${id}/download`,
    method: "GET",
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// TO BE DEPRECATED IN FAVOR OF uploadFaldonXlsx
const uploadFileByCategory = (data) => {
  return interceptors({
    url: "/documents/document",
    method: "POST",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// TO BE DEPRECATED
const fetchLastFiles = (limit) => {
  return interceptors({
    url: `/documents/document${!limit ? "" : `?latest=${10}`}`,
    method: "GET",
  });
};

// TO BE DEPRECATED
const deleteFile = (category, uuid) => {
  return interceptors({
    url: `/documents/document/${category}/${uuid}/`,
    method: "DELETE",
  });
};

const uploadFaldonXlsx = (file, username, faldon_version_json, category_menu = null) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("username", username);
  formData.append("faldon_version_json", JSON.stringify(faldon_version_json));
  formData.append("preview", false);
  const params = {};
  if (category_menu !== null && category_menu !== undefined && category_menu !== "") {
    params.category_menu = category_menu;
  }
  return interceptors({
    url: "/online-promocional/faldones/upload",
    method: "POST",
    data: formData,
    params: Object.keys(params).length > 0 ? params : undefined,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// New: Preview the update of an upload process for uploadFaldonXlsx
const previewUploadFaldonXlsx = (file, username, faldon_version_json, promotionId, categoryMenu = null) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("username", username);
  formData.append("faldon_version_json", JSON.stringify(faldon_version_json));
  formData.append("promotionId", promotionId);
  formData.append("preview", true);
  if (categoryMenu) formData.append("category_menu", categoryMenu);
  return interceptors({
    url: "/online-promocional/faldones/upload",
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

// New: Fetch faldones from online-promocional by category_menu and tienda
const fetchFaldonesByCategoryAndTienda = (
    tienda, username = null, ean = null, codigoSeccion = null,
    campana=null, producto=null, marca=null, categoria=null,
    created_at_from=null, created_at_to=null, start_date_from=null, start_date_to=null, end_date_from=null, end_date_to=null, 
    limit=null
  ) => {
  // Check if SMU_SELECTED_MENU is active with a valid value (not null, undefined or 0)
  /*
  let selectedMenuCategory = category_menu;
  const savedSelectedMenu = localStorage.getItem(SMU_SELECTED_MENU);
  if (savedSelectedMenu) {
    try {
      const parsedMenu = JSON.parse(savedSelectedMenu);
      const menuId = parsedMenu?.id;
      if (menuId !== null && menuId !== undefined && menuId !== 0) {
        selectedMenuCategory = menuId;
      }
    } catch (err) {
      // If parsing fails, use the original category_menu parameter
      console.error("Error parsing SMU_SELECTED_MENU:", err);
    }
  }*/

  var params ={
    //category_menu: selectedMenuCategory,
    tienda,
    ean,
    username,
    producto,
    categoria,
    marca
  }
  if (codigoSeccion) params.seccion = codigoSeccion;
  if (campana) params.faldon = campana;
  if (created_at_from) params.created_at_from = created_at_from;
  if (created_at_to) params.created_at_to = created_at_to;
  if (start_date_from) params.start_date_from = start_date_from;
  if (start_date_to) params.start_date_to = start_date_to;
  if (end_date_from) params.end_date_from = end_date_from;
  if (end_date_to) params.end_date_to = end_date_to;
  if (limit) params.limit = limit;
  return interceptors({
    //url: `/online-promocional/faldones?category_menu=${category_menu}&tienda=${tienda}`,
    url: `/online-promocional/faldones`,
    method: "GET",
    params
  });
};

// New: Fetch products from a faldon by faldon name
const fetchProductsByFaldonId = (faldon_name, tienda, username) => {
  const params = new URLSearchParams({ format: "json" });
  if (tienda && tienda !== -1) params.append('tienda', tienda);
  if (username) params.append('username', username);
  params.append('format', 'json');
  return interceptors({
    url: `/online-promocional/faldones/${encodeURIComponent(faldon_name)}?${params.toString()}`,
    method: "GET"
  })
}

// New: Fetch faldones by promotion ID
const fetchFaldonesByPromotionData = (promotionId, username, negocio, formatoImpresion, nombreCampana, payload) => {
  const params = new URLSearchParams({ username: username, negocio: negocio == null ? "" : negocio, formatoImpresion: formatoImpresion, nombreCampana: nombreCampana });
  for (const [key, value] of Object.entries(payload)) {
    if (value !== null && value !== undefined && value !== "" && !Array.isArray(value)) {
      params.append(key, value);
    }
    if (Array.isArray(value) && value.length > 0) {
      const valueString = value.map(v => String(v)).join(',');
      params.append(key, valueString);
    }
  }

  // Add category_menu if there is a valid selected menu
  if (!('category_menu' in payload)) {
    const menuId = getSelectedMenuId();
    if (menuId !== null) {
      params.append('category_menu', menuId);
    }
  }

  return interceptors({
    url: `/online-promocional/faldones/${promotionId}?${params.toString()}`,
    method: "GET"
  })
}

// New: Search faldones by name
const searchFaldonesByName = (name, tienda, username) => {
  const params = new URLSearchParams({ format: "json" });
  if (tienda) params.append('tienda', tienda);
  if (username) params.append('username', username);
  if (name) params.append('keyword', name.toUpperCase());
  return interceptors({
    url: `/online-promocional/faldones?${params.toString()}`,
    method: "GET",
    params: {
      format: "json",
    }
  })
}

// Download new faldon xlsx by filename, with optional params
const downloadFaldonXlsx = (filename, { tienda, username, eans, products, copies, negocio, formatoImpresion, nombreCampana, start_date_to, end_date_from, actualizaciones } = {}) => {
  const params = new URLSearchParams({ format: 'pdf' });
  if (tienda) params.append('tienda', tienda);
  if (username) params.append('username', username);
  if (Array.isArray(eans) && eans.length > 0) {
    const eansString = eans.map(e => String(e)).join(',');
    params.append('ean', eansString);
  }
  if (products) params.append('ids', products.join(',')); // internal ID
  if (copies) params.append('copies', copies);
  if (negocio) params.append('negocio', negocio);
  if (formatoImpresion) params.append('formatoImpresion', formatoImpresion);
  if (nombreCampana) params.append('nombreCampana', nombreCampana);
  if (start_date_to) params.append('start_date_to', start_date_to);
  if (end_date_from) params.append('end_date_from', end_date_from);
  if (actualizaciones) params.append('actualizaciones', actualizaciones);
  // Add category_menu if there is a valid selected menu
  const menuId = getSelectedMenuId();
  if (menuId !== null) {
    params.append('category_menu', menuId);
  }

  return interceptors({
    url: `/online-promocional/faldones/${encodeURIComponent(filename)}?${params.toString()}`,
    method: "GET",
    responseType: 'blob', // Ensure file download
  });
};

// Download new faldon xlsx by filename, with copies specified by parameter
const downloadFaldonXlsxWithCopies = (filename, { tienda, username, faldones, negocio, formatoImpresion, nombreCampana}) => {
  const params = new URLSearchParams({ format: 'pdf' });
  if (tienda) params.append('tienda', tienda);
  if (username) params.append('username', username);
  if (negocio) params.append('negocio', negocio);
  if (formatoImpresion) params.append('formatoImpresion', formatoImpresion);
  if (nombreCampana) params.append('nombreCampana', nombreCampana);
  if (faldones) params.append('faldonids', faldones.join('-!-'));

  // Add category_menu if there is a valid selected menu
  const menuId = getSelectedMenuId();
  if (menuId !== null) {
    params.append('category_menu', menuId);
  }

  return interceptors({
    url: `/online-promocional/faldones/${encodeURIComponent(filename)}?${params.toString()}`,
    method: "GET",
    responseType: 'blob', // Ensure file download
  });
}

// Download new faldon xlsx by promotionId, with copies and version specified by parameter faldonId|copies|version-!-faldonId|copies|version
// NOTE add negocio, formatoImpresion, nombreCampana as params
const downloadFaldonXlsxByPromotionIdWithCopiesAndVersion = (promotionId, { tienda, username, negocio, formatoImpresion, nombreCampana, faldones }) => {
  const params = new URLSearchParams({ format: 'pdf' });
  if (tienda) params.append('tienda', tienda);
  if (username) params.append('username', username);
  if (negocio) params.append('negocio', negocio);
  if (formatoImpresion) params.append('formatoImpresion', formatoImpresion);
  if (nombreCampana) params.append('nombreCampana', nombreCampana);
  if (faldones) params.append('faldonids', faldones.join('-!-'));
  return interceptors({
    url: `/online-promocional/faldones/${promotionId}?${params.toString()}`,
    method: "GET",
    responseType: 'blob', // Ensure file download
  });
}

const fetchPreviousVersionData = async (faldonId, faldonName, username, version, formatoImpresion, negocio) => {
  const params = new URLSearchParams({ format: 'json' });
  if (username) params.append('username', username);
  if (formatoImpresion) params.append('formatoImpresion', formatoImpresion);
  if (negocio) params.append('negocio', negocio);
  // faldonids format: "faldonName|1" (1 is the amount of copies needed)
  if (faldonName) {
    params.append('faldonids', `${faldonName}|1`);
  }
  // previousVersion as version parameter
  const previousVersion = version > 1 ? version - 1 : 1;
  params.append('version', previousVersion);
  // Use faldonId in the URL path
  return interceptors({
    url: `/online-promocional/faldones/${encodeURIComponent(faldonId)}?${params.toString()}`,
    method: 'GET'
  });
};

// Latest user skirt download status
const getLatestDownloadFaldonStatus = (filename, username) => {
  const params = {
    type: "downloads",
    username: username,
    faldon: filename
  };
  return interceptors({
    url: `/online-promocional/faldones/reports`,
    method: "GET",
    params
    }).then(response => {
      if (Array.isArray(response?.data) && response?.data?.length > 0) {
        return response.data[0];
      }
      return response;
    });
};

const deleteFaldonXlsx = (filename, username) => {
  const params = new URLSearchParams();
  if (username) params.append('username', username);
  return interceptors({
    url: `/online-promocional/faldones/${encodeURIComponent(filename)}${params.toString() ? '?' + params.toString() : ''}`,
    method: "DELETE",
  });
};

// New. Fetch skirts by campaign ID
const fetchSkirtsByCampaignId = (campaignId, username) => {
  const params = new URLSearchParams({ format: "json", username: username });
  return interceptors({
    url: `/online-promocional/faldones/${campaignId}?${params.toString()}`,
    method: "GET",
  });
};

const validatePromotionalCampaign = (campaignId, username) => {
  const params = new URLSearchParams({ format: "json", username: username });
  return interceptors({
    url: `/online-promocional/faldones/${campaignId}?${params.toString()}`,
    method: "GET",
  });
};

const previewXlsxSkirts = (file, username) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("username", username);
  return interceptors({
    url: "/online-promocional/faldones/preview",
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    responseType: 'blob',
  });
}

export {
  downloadFile,
  deleteFaldonXlsx,
  fetchFiles,
  uploadFileByCategory,
  fetchLastFiles,
  deleteFile,
  uploadFaldonXlsx,
  fetchFaldonesByCategoryAndTienda,
  downloadFaldonXlsx,
  downloadFaldonXlsxWithCopies,
  getLatestDownloadFaldonStatus,
  fetchProductsByFaldonId,
  searchFaldonesByName,
  fetchSkirtsByCampaignId,
  validatePromotionalCampaign,
  previewXlsxSkirts,
  fetchPreviousVersionData,
  fetchFaldonesByPromotionData,
  downloadFaldonXlsxByPromotionIdWithCopiesAndVersion,
  previewUploadFaldonXlsx,
};